import PropTypes from "prop-types"
import { Alert, Typography } from "@mui/material"
import { withLoading } from "./WithLoading"
import { getConfig } from "../../../config"

export const EntitlexGuardComponent = ({ isAvailable, hasAdminAccess, children }) => {
  if (!isAvailable) {
    return (
      <>
        <Alert severity="warning">
          EntitleX API is not available.
          <br />
          <Typography variant="subtitle1">
            Please make sure EntitleX API ({getConfig().entitlexApiOrigin}) is available and SSO token is
            valid for it.
          </Typography>
        </Alert>
      </>
    )
  }
  if (!hasAdminAccess) {
    return (
      <>
        <Alert severity="info">
          EntitleX Admin API is not available.
          <br />
          <Typography variant="subtitle1">
            You are currently using EntitleX API at ({getConfig().entitlexApiOrigin}) <br />
            Your user does not have access to admin api, list of all available applications can not be
            loaded. <br />
            Please use free form input, type and hit enter to specify application name to get permissions
            for.
          </Typography>
        </Alert>

        {children}
      </>
    )
  }

  return children
}

EntitlexGuardComponent.propTypes = {
  children: PropTypes.node,
  isAvailable: PropTypes.bool,
  hasAdminAccess: PropTypes.bool
}

export const EntitlexGuard = withLoading(EntitlexGuardComponent)
